import type { BadgeVariants } from "@/components/ui/Badge";
import { InductionStatus } from "@/features/induction/induction.enums";

/**
 * Maps workforce induction statuses to badge variants.
 *
 * @param {InductionStatus | undefined} status - Induction status value.
 * @returns {BadgeVariants} Badge variant for the provided status.
 */
export const getInductionStatusBadgeVariant = (
  status: InductionStatus | undefined,
): BadgeVariants => {
  switch (status) {
    case InductionStatus.PENDING:
      return "lightYellow";
    case InductionStatus.APPROVED:
      return "lightSuccess";
    case InductionStatus.REVOKED:
      return "lightDestructive";
    default:
      return "secondary";
  }
};
